import { observer } from "mobx-react-lite";
import styles from "./Permissions.module.css";
import { userStore } from "@/stores/UserStore";

export const ActiveUser = observer(() => {
  return (
    <div className={styles.iterationPermissions}>
      <div className={styles.titleSection}>
        <span>Активность учетной записи:</span>
        <span
          className={`${styles.typePermissions} ${userStore.active ? styles.active : ""}`}
          role-id={userStore.role}
        >
          {userStore.active ? "Активна" : "Не активна"}
        </span>
      </div>
    </div>
  );
});
